import { render, staticRenderFns } from "./relevance-form-dropdown.vue?vue&type=template&id=a482e38e&scoped=true&"
import script from "./relevance-form-dropdown.vue?vue&type=script&lang=ts&"
export * from "./relevance-form-dropdown.vue?vue&type=script&lang=ts&"
import style0 from "./relevance-form-dropdown.vue?vue&type=style&index=0&lang=less&"
import style1 from "./relevance-form-dropdown.vue?vue&type=style&index=1&id=a482e38e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a482e38e",
  null
  
)

export default component.exports